import { FEATURE_TOGGLE_CONFIG } from '@wdpr/ra-angular-feature-toggle';
var ɵ0 = {
    wdprConversationCookieName: 'Conversation_UUID',
    wdprConversationHeader: 'X-Conversation-Id',
    wdprCorrelationHeader: 'X-Correlation-Id',
    wdprEndpointFilter: '(/error/?|homepage-banner-toggles\.json)'
}, ɵ1 = FEATURE_TOGGLE_CONFIG;
var CoreModule = /** @class */ (function () {
    function CoreModule() {
    }
    return CoreModule;
}());
export { CoreModule };
export { ɵ0, ɵ1 };
